<template>
  <v-container
    id="contrato"
    fluid
    tag="section"
    class="parent-container"
    style="height: calc(90vh - 65px); background-color: #f8f9fb; padding: 0; margin: 0;"
  >
    <div>
      <img
        src="../../assets/lg_grupo.png"
        width="80%"
        style="max-width: 300px"
      />
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Inicio",

  components: {},

  data() {
    return {};
  },

  mounted() {
    // Fecha a sidebar ao abrir a tela de módulos
    this.$store.commit("SET_DRAWER", true);
    // Se nenhum módulo estiver selecionado, redireciona para seleção de módulos
    if (!this.$store.state.selectedModule) {
      this.$router.push("/modulos");
    }
  },

  methods: {},
};
</script>

<style scoped>
.parent-container {
  display: flex;
  justify-content: center; /* Centralizar horizontalmente */
  align-items: center; /* Centralizar verticalmente */
}

.parent-container img {
  max-width: 100%;
  max-height: 100%;
}
</style>
